/**
 * Text messages used for tooltips and informational notes about the tooltips across the application.
 */

export const GridTooltipHelperMessages = {
    headerTooltipInfoNote:
        'More information for columns in the table can be found when hovering over the header text.',
    actionCodeDescriptionTooltip:
        "This item indicates the action the filer wants the FCC to take on the specified control point. Enter 'A' for Add, 'M' for Modify, or 'D' for Delete.",
};
